/** Domain used in LMS/content preview before assessment personalization. */
export const PREVIEW_TEMPLATE_DOMAIN = 'your-company.com';

export function getAssessmentCompanyDomain(assessmentStore, questionStore) {
    const fromQuestion =
        questionStore?.question?.ui?.presentation?.personalizedData
            ?.companyDomain;
    if (fromQuestion) return fromQuestion;

    let definition = assessmentStore?.assessment?.definition;
    if (typeof definition === 'string') {
        try {
            definition = JSON.parse(definition);
        } catch {
            return null;
        }
    }
    return definition?.personalizeData?.companyDomain || null;
}

/** Keys to check for overrides (personalized value, then preview template). */
export function translationLookupKeys(key, companyDomain) {
    const keys = [key];
    if (
        companyDomain &&
        companyDomain !== PREVIEW_TEMPLATE_DOMAIN &&
        key.includes(companyDomain)
    ) {
        keys.push(
            key.split(companyDomain).join(PREVIEW_TEMPLATE_DOMAIN)
        );
    }
    return keys;
}

export function lookupTranslationOverride(
    lookupKeys,
    lng,
    { questionTranslations, assessmentTranslations, branding }
) {
    const sources = [
        questionTranslations,
        assessmentTranslations,
        branding,
    ].filter(Boolean);

    for (const key of lookupKeys) {
        const fullKey = `ui.translation.${lng}.${key}`;
        for (const source of sources) {
            const override = source[fullKey];
            if (override !== undefined && override !== null && override !== '') {
                return override;
            }
        }
    }
    return null;
}
